import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import _ from 'lodash';

const FormikFocusError: React.FC = () => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const errorKeys = Object.keys(errors);
      if (errorKeys.length > 0) {
        const errorElements = new Array(0);
        // 取得所有錯誤欄位
        _.forEach(errorKeys, (errorKey:string) => {
          const errorElement = document.querySelector(`[data-fieldname=${errorKey}]`) as HTMLElement;
          if (errorElement) {
            errorElements.push(errorElement);
          }
        });
        // 排序錯誤欄位
        errorElements.sort((a:HTMLElement, b:HTMLElement) => a.tabIndex - b.tabIndex);
        // 取得 tabIndex 編號最小的欄位
        const errorElement = errorElements[0] as HTMLElement;
        if (errorElement) {
          const top = errorElement.offsetTop;
          const headerHeight = document.getElementsByTagName('header')[0].clientHeight;

          if (top === 0) {
            errorElement.focus();
          } else {
            errorElement.focus();
            window.scrollTo({ top: top - headerHeight });
          }
        }
      }
    }
  }, [errors, isSubmitting, isValidating]);

  return null;
};

export default FormikFocusError;
